export class AzureDiskRestoreResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "diskId",
            "baseName": "diskId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureDiskRestoreResult.attributeTypeMap;
    }
    constructor() {
    }
}
